import React from 'react';
import { Typography } from '@scale/scaleui';

interface FeedbackBadgeProps {
  variant?: string;
  children: React.ReactNode;
}

export const priorityVariantMapping: { [key: number]: string } = {
  0: 'danger',
  1: 'warning',
  2: 'success',
  3: 'success',
};

export const priorityTextMapping: { [key: number]: string } = {
  0: 'Critical',
  1: 'Warning',
  2: 'Consider',
  3: 'Suggestion',
};

const AutoFeedbackBadge: React.FC<FeedbackBadgeProps> = ({ children, variant }) => {
  return (
    <div
      className={`px-3 py-1 rounded-full text-${variant ?? 'neutral'}-800 bg-${
        variant ?? 'neutral'
      }-100 border border-${variant ?? 'neutral'}-200 font-medium w-fit`}
    >
      <Typography.Paragraph1>
        <div className={`text-xs text-${variant ?? 'neutral'}-900`}>{children}</div>
      </Typography.Paragraph1>
    </div>
  );
};

export default AutoFeedbackBadge;
